import React from "react";
import { Button } from "@mui/material";
import { Box, Paper, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import logo from './assets/MyImg/welcom-img.png';

// Styled button
const CustomButton = styled(Button)({
  backgroundColor: "#222",
  color: "#fff",
  fontWeight: "bold",
  textTransform: "none",
  fontSize: "18px",
  padding: "12px 198px",
  borderRadius: "8px",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
  "&:hover": {
    backgroundColor: "#444",
  },
  "@media (max-width: 600px)": {
    padding: "10px 50px",
    fontSize: "14px",
  },
});

const WelcomePage = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        minWidth: "100vw",
        backgroundColor: "#00C0C0",
        overflow: "hidden", // Prevent floating
      }}
    >
      <Paper
        elevation={6}
        sx={{
          padding: "50px 130px",
          borderRadius: "15px",
          textAlign: "center",
          width: "600px",
          height: "400px",
          display: "flex", // Ensure proper centering
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          "@media (max-width: 900px)": {
            width: "80%",
            padding: "40px 20px",
          },
          "@media (max-width: 600px)": {
            width: "90%",
            padding: "30px 15px",
          },
        }}
      >
        {/* Logo Section */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: 5,
            "@media (max-width: 600px)": {
              mb: 3,
            },
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{
              width: "500px",
              "@media (max-width: 900px)": {
                width: "300px",
              },
              "@media (max-width: 600px)": {
                width: "250px",
              },
            }}
          />
        </Box>

        {/* Subtitle */}
        <Typography
          variant="h1"
          sx={{
            marginTop: "-32px",
            marginBottom: "40px",
            marginLeft: "-40px",
            fontWeight: "bold",
            color: "black",
            fontSize: "18px",
            fontFamily: "Montserrat, sans-serif",
            "@media (max-width: 900px)": {
              fontSize: "16px",
              marginLeft: "0",
            },
            "@media (max-width: 600px)": {
              fontSize: "14px",
              marginBottom: "20px",
            },
          }}
        >
          Streamline your billing and management with <br /> ease and accuracy
        </Typography>

        {/* Button */}
        <Box
          mt={3}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              navigate("/login");
            }
          }}
        >
          <CustomButton onClick={() => navigate("/login")}>Let's Go!!!</CustomButton>
        </Box>
      </Paper>
    </Box>
  );
};

export default WelcomePage;